import Color from 'color'

const white = Color('#FFFFFF')
const black = Color('#000000')

export interface PrimaryColors {
  primary130: string
  primary120: string
  primary110: string
  primary70: string
  primary30: string
  primary10: string
  primary05: string
}

export const getPrimaryColors = (baseColor: string): PrimaryColors => {
  return {
    primary130: Color(baseColor).mix(black, 0.2).hex(),
    primary120: Color(baseColor).mix(black, 0.1).hex(),
    primary110: baseColor,
    primary70: Color(baseColor).mix(white, 0.3).hex(),
    primary30: Color(baseColor).mix(white, 0.7).hex(),
    primary10: Color(baseColor).mix(white, 0.9).hex(),
    primary05: Color(baseColor).mix(white, 0.95).hex(),
  }
}
